/**
 * Formatting utilities for displaying data
 */

/**
 * Format price with thousand separators
 * @param price - Price in PHP
 * @param includeCurrency - Whether to include ₱ symbol (default: true)
 * @returns Formatted price string
 *
 * @example
 * formatPrice(3252000000) // "₱3,252,000,000"
 * formatPrice(21000000) // "₱21,000,000"
 * formatPrice(750000, false) // "750,000"
 */
export function formatPrice(price: number | null | undefined, includeCurrency: boolean = true): string {
  if (price === null || price === undefined || isNaN(price)) {
    return includeCurrency ? '₱0' : '0'
  }

  const formatted = Math.round(price).toLocaleString('en-PH')
  return includeCurrency ? `₱${formatted}` : formatted
}

/**
 * Format area with square meter unit
 * @param area - Area in square meters
 * @returns Formatted area string
 *
 * @example
 * formatArea(450) // "450 sqm"
 * formatArea(1000.5) // "1,001 sqm"
 */
export function formatArea(area: number | null | undefined): string {
  if (area === null || area === undefined || isNaN(area)) {
    return ''
  }

  return `${Math.round(area).toLocaleString('en-PH')} sqm`
}

/**
 * Format number with thousand separators
 * @param num - Number to format
 * @returns Formatted number string
 *
 * @example
 * formatNumber(1234567) // "1,234,567"
 */
export function formatNumber(num: number | null | undefined): string {
  if (num === null || num === undefined || isNaN(num)) {
    return '0'
  }

  return Math.round(num).toLocaleString('en-PH')
}
